import React from 'react';
import {AuthProvider} from '../context/AuthContext';
import Routes from './Routes';
import {PegAmountProvider} from "../context/PegAmountContext";
import {ClubDetailsProvider} from "../context/ClubDetailsContext";
import {HistoryProvider} from "../context/HistoryContext";

const Providers = () => {
  return (
      <AuthProvider>
          <ClubDetailsProvider>
            <HistoryProvider>
                <PegAmountProvider>
                  <Routes />
                </PegAmountProvider>
            </HistoryProvider>
          </ClubDetailsProvider>
      </AuthProvider>
  );
};

export default Providers;
